export const logError = (error: string | Error) => {
  console.error(error);

  // to-do: send error to Sentry
}